// Localização: frontend/src/api/stripeApi.js
// API service para integração com Stripe

import api from './api';

/**
 * Cria checkout session no Stripe
 * @param {number} plano_id - ID do plano selecionado
 * @returns {Promise<object>} Resposta com client_secret e subscription_id
 */
export const createCheckout = async (plano_id) => {
    try {
        const response = await api.post('/stripe/checkout', {
            plano_id
        });
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao criar checkout:', error);
        throw error;
    }
};

/**
 * Cancela assinatura no Stripe
 * @param {string} subscription_id - ID da subscription no Stripe
 * @param {boolean} cancel_immediately - Se true, cancela imediatamente
 * @returns {Promise<object>} Resposta com status do cancelamento
 */
export const cancelSubscription = async (subscription_id, cancel_immediately = false) => {
    try {
        const response = await api.post('/stripe/cancel', {
            subscription_id,
            cancel_immediately
        });
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao cancelar assinatura:', error);
        throw error;
    }
};

/**
 * Atualiza assinatura (mudança de plano)
 * @param {string} subscription_id - ID da subscription no Stripe
 * @param {number} new_plano_id - ID do novo plano
 * @returns {Promise<object>} Resposta com subscription atualizada
 */
export const updateSubscription = async (subscription_id, new_plano_id) => {
    try {
        const response = await api.put('/stripe/update', {
            subscription_id,
            new_plano_id
        });
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao atualizar assinatura:', error);
        throw error;
    }
};

/**
 * Obtém detalhes de uma subscription
 * @param {string} subscription_id - ID da subscription no Stripe
 * @returns {Promise<object>} Detalhes da subscription
 */
export const getSubscription = async (subscription_id) => {
    try {
        const response = await api.get(`/stripe/subscription/${subscription_id}`);
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao buscar subscription:', error);
        throw error;
    }
};

/**
 * Lista métodos de pagamento de um customer
 * @param {string} customer_id - ID do customer no Stripe
 * @returns {Promise<Array>} Lista de payment methods
 */
export const listPaymentMethods = async (customer_id) => {
    try {
        const response = await api.get(`/stripe/payment-methods?customer_id=${customer_id}`);
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao listar payment methods:', error);
        throw error;
    }
};

/**
 * Adiciona método de pagamento a um customer
 * @param {string} customer_id - ID do customer no Stripe
 * @param {string} payment_method_id - ID do payment method (gerado no frontend)
 * @returns {Promise<object>} Resposta com status
 */
export const addPaymentMethod = async (customer_id, payment_method_id) => {
    try {
        const response = await api.post('/stripe/payment-methods', {
            customer_id,
            payment_method_id
        });
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao adicionar payment method:', error);
        throw error;
    }
};

/**
 * Remove método de pagamento
 * @param {string} payment_method_id - ID do payment method
 * @returns {Promise<object>} Resposta com status
 */
export const removePaymentMethod = async (payment_method_id) => {
    try {
        const response = await api.delete(`/stripe/payment-methods/${payment_method_id}`);
        return response.data;
    } catch (error) {
        console.error('[StripeAPI] Erro ao remover payment method:', error);
        throw error;
    }
};

